import React, { useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { v4 as uuid } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

function DnDPageOrder(props) {
    let currentPageId = props.currentPageId;

    const columnsFromBackend = {
        [uuid()]: {
            parentName: props.parentPageName,
            name: 'Menu Order:',
            items: props.pages 
        }
    };

    const onDragEnd = (result, columns, setColumns) => {
        if (!result.destination) return;
        const { source, destination } = result;
        if (source.droppableId !== destination.droppableId) {//Between columns
            const sourceColumn = columns[source.droppableId];
            const destColumn = columns[destination.droppableId];
            const sourceItems = [...sourceColumn.items];
            const destItems = [...destColumn.items];
            const [removed] = sourceItems.splice(source.index, 1);
            destItems.splice(destination.index, 0, removed);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...sourceColumn,
                    items: sourceItems
                },
                [destination.droppableId]: {
                    ...destColumn,
                    items: destItems
                }
            })
        }
        else {//Within column 
            const column = columns[source.droppableId];
            const copiedItems = [...column.items];
            const [removed] = copiedItems.splice(source.index, 1);
            copiedItems.splice(destination.index, 0, removed);
            setColumns({
                ...columns,
                [source.droppableId]: {
                    ...column,
                    items: copiedItems
                }
            });

            props.pageOrderUpdate(copiedItems);
        }
    }

    const [columns, setColumns] = useState(columnsFromBackend);

    return (
        <div style={{ display: 'flex', justifyContext: 'center', height: '100%' }}>
            <DragDropContext onDragEnd={result => onDragEnd(result, columns, setColumns)}>
                {Object.entries(columns).map(([id, column]) => {
                    return (
                        <div key={id} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', background: 'rgb(239, 239, 239)' }}>
                            <label style={{ fontWeight: 'bold', marginBottom: '0', wordBreak: 'break-word' }}>{column.parentName}</label>
                            <label style={{ fontWeight: 'bold', marginBottom: '0.4rem' }}>{column.name}</label>
                            <div>
                                <Droppable droppableId={id} key={id}>
                                    {(provided, snapshot) => {
                                        return (
                                            <div
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{
                                                    background: snapshot.isDraggingOver ? 'lightblue' : '#efefef',
                                                    padding: 4,
                                                    width: 250,
                                                    minHeight: 450
                                                }}
                                            >
                                                {column.items.map((item, index) => {
                                                    return (
                                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                                            {(provided, snapshot) => {
                                                                return (
                                                                    <div
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                        style={{
                                                                            wordBreak: 'break-word',
                                                                            textAlign: 'left',
                                                                            userSelect: 'none',
                                                                            padding: 16,
                                                                            margin: '0 0 8px 0',
                                                                            minHeight: '50px',
                                                                            backgroundColor: snapshot.isDragging ? '#263b4a' : '#456c86',
                                                                            color: item.id == currentPageId || item.id == 'new' ? 'yellow' : 'white',
                                                                            ...provided.draggableProps.style
                                                                        }}
                                                                    >
                                                                        <FontAwesomeIcon icon={faEllipsisV} style={{marginRight: '5%'}} />
                                                                        {item.content}
                                                                    </div>
                                                                )
                                                            }}
                                                        </Draggable>
                                                    )
                                                })}
                                                {provided.placeholder}
                                            </div>
                                        )
                                    }}
                                </Droppable>
                            </div>
                        </div>
                    )
                })}
            </DragDropContext>
        </div>
    );
}

export default DnDPageOrder;
